import { Collapse, makeStyles, Typography } from '@material-ui/core';
import green from '@material-ui/core/colors/green';
import cx from 'clsx';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import React from 'react';

const styles = makeStyles(({ spacing, palette, shape }) => {
    return {
        root: {
            padding: spacing(2),
            margin: spacing(2, 0),
            display: 'flex',
            alignItems: 'center',
            borderRadius: shape.borderRadius,
        },
        error: {
            // backgroundColor: '#F7F7F7',
            backgroundColor: palette.error.main,
        },
        success: {
            backgroundColor: green[400],
        },
        text: {
            display: 'flex',
            fontSize: 14,
            fontWeight: 500,
            alignItems: 'center',
        },
        textSuccess: {
            color: palette.common.white,
        },
        textError: {
            color: palette.common.white,
        },
        icon: {
            fontSize: 20,
            marginRight: spacing(1),
            color: '#FFF',
        },
    };
});

const propTypes = { message: PropTypes.string };
const defaultProps = { message: '' };

function alert({ errors, status, children, message }) {
    const classes = styles();
    let text = '';
    if (message) {
        text = message;
    } else if (!isEmpty(errors)) {
        text = errors.message;
        status = 'error';
    }

    const classStatus = status === 'error' ? classes.error : classes.success;
    const classText = status === 'error' ? classes.textError : classes.textSuccess;

    return (
        <Collapse in={!isEmpty(text)}>
            <div className={cx(classes.root, classStatus)}>
                {/* <Icon className={classes.icon}>close</Icon> */}
                <Typography
                    variant="subtitle1"
                    className={cx(classes.text, classText)}
                >
                    {text}
                </Typography>
                {children}
            </div>
        </Collapse>
    );
}

alert.propTypes = propTypes;
alert.defaultProps = defaultProps;

export default alert;
